import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServicesRoutingModule } from './services-routing.module';
import { ServicesComponent } from './services.component';
import { ServicesBannerComponent } from './services-banner/services-banner.component';
import { MatButtonModule } from '@angular/material/button';
import { OfferServicesComponent } from './offer-services/offer-services.component';
import { MiniBannerModule } from '../shared/components/mini-banner/mini-banner.module';
import { FrequentlyQuestionsModule } from '../shared/components/frequently-questions/frequently-questions.module';
import { SubsPlansModule } from '../shared/components/subs-plans/subs-plans.module';

@NgModule({
  declarations: [ServicesComponent, ServicesBannerComponent, OfferServicesComponent],
  imports: [
    CommonModule,
    ServicesRoutingModule,
    MatButtonModule,
    MiniBannerModule,
    FrequentlyQuestionsModule,
    SubsPlansModule
  ],
})
export class ServicesModule { }
